var _rect, _path, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 24,
    viewBox: "0 0 34 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 33,
    height: 23,
    rx: 3.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.751 15.8579H8.69129L7.14674 9.79198C7.07343 9.51295 6.91776 9.26627 6.68879 9.15001C6.11737 8.85784 5.4877 8.62531 4.80078 8.50804V8.2745H8.11886C8.57681 8.2745 8.92026 8.62531 8.97751 9.03274L9.77891 13.4083L11.8376 8.2745H13.8401L10.751 15.8579ZM14.985 15.8579H13.0398L14.6415 8.2745H16.5868L14.985 15.8579ZM19.1035 10.3753C19.1607 9.96689 19.5042 9.73335 19.9049 9.73335C20.5346 9.67471 21.2205 9.79199 21.7929 10.0832L22.1364 8.45042C21.5639 8.21688 20.9343 8.09961 20.3628 8.09961C18.4748 8.09961 17.101 9.15002 17.101 10.6078C17.101 11.7169 18.0741 12.2992 18.761 12.65C19.5042 12.9998 19.7904 13.2334 19.7332 13.5832C19.7332 14.1079 19.1607 14.3414 18.5893 14.3414C17.9024 14.3414 17.2155 14.1665 16.5868 13.8743L16.2433 15.5081C16.9303 15.7992 17.6734 15.9165 18.3603 15.9165C20.4773 15.9741 21.7929 14.9247 21.7929 13.3496C21.7929 11.3661 19.1035 11.2498 19.1035 10.3753ZM28.6008 15.8579L27.0562 8.2745H25.3972C25.0537 8.2745 24.7103 8.50804 24.5958 8.85784L21.7356 15.8579H23.7381L24.1378 14.7498H26.5983L26.8273 15.8579H28.6008ZM25.6834 10.3167L26.2548 13.1747H24.653L25.6834 10.3167Z",
    fill: "#172B85"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 33,
    height: 23,
    rx: 3.5,
    stroke: "#F5F5F5"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.a5474ea282fc59859be7cfd5c926dbb3.svg";
export { ForwardRef as ReactComponent };